/**
 * Ikaros grid swatches.
 *
 * Clicking a colour on a family card swaps the card's photograph and
 * re-points its link at that colourway, so a customer can find the colour
 * they want before leaving the grid. Nothing navigates until they click the
 * card itself.
 *
 * Progressive by design: the markup ships with the first product's image
 * and URL already in place, so with JavaScript off the card still works -
 * it simply does not switch. That is why the swatches are buttons rather
 * than links; a link would navigate on click and defeat the point, and a
 * link nested inside the card's own anchor would be invalid markup.
 *
 * Hover previews and click commits. Moving the mouse across a row of
 * eighteen colours should not leave the card showing whichever one the
 * pointer happened to exit over, so leaving the strip restores the last
 * committed choice rather than the original.
 */

(() => {
  function wire(card) {
    const strip = card.querySelector('[data-ikg-swatches]');
    const img = card.querySelector('[data-ikg-img]');
    const link = card.querySelector('[data-ikg-link]');
    const meta = card.querySelector('[data-ikg-meta]');
    if (!strip || !link) return;

    const swatches = [...strip.querySelectorAll('[data-ikg-swatch]')];
    if (!swatches.length) return;

    // What the card returns to: the first product, as rendered by Liquid.
    const base = {
      img: img ? img.getAttribute('data-default') : null,
      url: link.getAttribute('href'),
      meta: meta ? meta.getAttribute('data-default') : null,
    };
    let committed = null;

    const show = (state) => {
      if (img && state.img) img.src = state.img;
      if (state.url) link.href = state.url;
      if (meta) meta.textContent = state.meta || base.meta;
    };

    const stateFor = (btn) => ({
      img: btn.getAttribute('data-img') || base.img,
      url: btn.getAttribute('data-url') || base.url,
      meta: btn.getAttribute('data-label') || base.meta,
    });

    swatches.forEach((btn) => {
      btn.addEventListener('mouseenter', () => show(stateFor(btn)));
      btn.addEventListener('focus', () => show(stateFor(btn)));

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        committed = stateFor(btn);
        swatches.forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
        show(committed);
      });
    });

    strip.addEventListener('mouseleave', () => show(committed || base));
  }

  function init() {
    document.querySelectorAll('[data-ikg-card]:not([data-ikg-ready])').forEach((card) => {
      card.setAttribute('data-ikg-ready', 'true');
      try {
        wire(card);
      } catch (e) {
        console.warn('[ikaros-grid-swatches]', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  ['shopify:section:load', 'shopify:section:select'].forEach((evt) =>
    document.addEventListener(evt, init)
  );
})();
